import { Controller } from '@hotwired/stimulus';
import { MQ } from '../tools/MQ';

export const create = () => {
	return class extends Controller {
		static targets = ['list', 'item', 'submenuTrigger'];
		static values = { desktopMq: { type: String, default: 'xlUp' } };

		toggleSubmenu({ currentTarget }) {
			const li = this.itemTargets.find((item) => item.contains(currentTarget));
			if (!li) return;
			const open = !li.classList.contains('is-open');
			this.setSubmenuOpen(li, open);
			if (open && !MQ(this.desktopMqValue)) {
				this.listTarget?.querySelectorAll(':scope > li.is-open').forEach((row) => {
					if (row !== li) this.setSubmenuOpen(row, false);
				});
			}
		}

		openSubmenuFromLink(event) {
			if (!document.documentElement.classList.contains('no-hoverevents') || !MQ(this.desktopMqValue)) return;
			const li = this.itemTargets.find((item) => item.contains(event.currentTarget));
			if (!li || li.classList.contains('is-open')) return;
			event.preventDefault();
			this.setSubmenuOpen(li, true);
		}

		handleEscape(event) {
			if (event.key !== 'Escape') return;
			const openLi = this.listTarget?.querySelector(':scope > li.is-open');
			if (openLi) {
				const btn = this.submenuTriggerTargets.find((b) => openLi.contains(b));
				this.setSubmenuOpen(openLi, false);
				requestAnimationFrame(() => btn?.focus());
			} else if (this.element.classList.contains('is-open')) this.closeDrawerThroughHeader();
		}

		handleOutside(event) {
			const t = event.target;
			if (!(t instanceof Node)) return;

			// When the header's hamburger button is outside this <nav>, treat it as an "inside" click,
			// otherwise opening the drawer would immediately trigger close on the same click.
			if (t instanceof Element && t.closest('[data-header-target="menuToggle"]')) return;
			// In mobile drawer mode, the header dropdown can contain elements outside this <nav>
			// (language switcher, sign-in, search). Treat clicks inside the header as "inside" clicks.
			const headerEl = this.element.closest('[data-controller~="header"]');
			if (headerEl && headerEl.classList.contains('is-menu-open') && headerEl.contains(t)) return;
			if (this.element.classList.contains('is-open') && !this.element.contains(t)) {
				this.closeDrawerThroughHeader();
				return;
			}

			const list = this.listTarget;
			if (!list) return;

			if (!MQ(this.desktopMqValue)) {
				if (!list.querySelector(':scope > li.is-open') || list.contains(t)) return;
				list.querySelectorAll(':scope > li.is-open').forEach((li) => this.setSubmenuOpen(li, false));
			} else {
				list.querySelectorAll(':scope > li.is-open').forEach((li) => {
					if (!li.contains(t)) this.setSubmenuOpen(li, false);
				});
			}
		}

		closeDrawerThroughHeader() {
			const headerEl = this.element.closest('[data-controller~="header"]');
			const hc = headerEl && this.application.getControllerForElementAndIdentifier(headerEl, 'header');
			if (hc?.closeMenu) hc.closeMenu();
			else {
				this.element.classList.remove('is-open');
				this.closeAllSubmenus();
			}
		}

		closeAllSubmenus() {
			this.listTarget?.querySelectorAll(':scope > li.is-open').forEach((li) => this.setSubmenuOpen(li, false));
		}

		setSubmenuOpen(li, open) {
			li.classList.toggle('is-open', open);
			const btn = this.submenuTriggerTargets.find((b) => li.contains(b));
			btn?.setAttribute('aria-expanded', String(open));
			btn?.classList.toggle('is-open', open);
		}
	};
};
